import { Directive, ElementRef, HostListener, Renderer2, input, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appArabicToEnglish]',
  standalone: true,
})
export class ArabicToEnglishDirective {
  private el = inject(ElementRef);
  private ngControl = inject(NgControl);


  @HostListener('input', ['$event']) onInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    const convertedValue = this.convertArabicToEnglish(inputValue);
    this.el.nativeElement.value = convertedValue;
    this.ngControl.control?.setValue(convertedValue, { emitEvent: false });
  }

  private convertArabicToEnglish(value: string): string {
    const arabicNumerals = '٠١٢٣٤٥٦٧٨٩';
    const arabicComma = '،';
    const englishNumerals = '0123456789';
    const englishComma = ',';

    for (let i = 0; i < arabicNumerals.length; i++) {
      value = value.replace(new RegExp(arabicNumerals[i], 'g'), englishNumerals[i]);
    }
    // Replace Arabic comma with English comma
    value = value.replace(new RegExp(arabicComma, 'g'), englishComma);
    value = value.replace(/,/g, '');

    return value;
  }
}

@Directive({
  selector: '[appNumberFormat]',
  standalone: true,
})
export class NumberFormatDirective {
  private el = inject(ElementRef);
  private ngControl = inject(NgControl);

  readonly conditionToFormat = input<boolean>(false);
  readonly mode = input<string>("decimal");
  readonly maxFractionDigits = input<number>(2);

  @HostListener('input', ['$event']) onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    const sanitizedValue = value.replace(/[^\d٠-٩.]/g, '');
    // Replace Arabic numerals with standard English numerals
    value = sanitizedValue
      .replace(/٠/g, '0')
      .replace(/١/g, '1')
      .replace(/٢/g, '2')
      .replace(/٣/g, '3')
      .replace(/٤/g, '4')
      .replace(/٥/g, '5')
      .replace(/٦/g, '6')
      .replace(/٧/g, '7')
      .replace(/٨/g, '8')
      .replace(/٩/g, '9');

      if(this.conditionToFormat())
      {
        let sanitized: string;
        if(this.mode() =='number')
        {
          sanitized = value.replace(/\D/g,'');
        }
        else{
          sanitized = value.replace(/[^\d.]/g, '');
          sanitized = sanitized.replace(/\.{2,}/g, '.');
          const decimalSeparatorIndex = sanitized.indexOf('.');
          if (decimalSeparatorIndex !== -1) {
            const integerPart = sanitized.slice(0, decimalSeparatorIndex);
            const decimalPart = sanitized.slice(decimalSeparatorIndex + 1).replace(/\./g, '');
            sanitized = `${integerPart}.${decimalPart.slice(0, this.maxFractionDigits())}`;
          }
        }

        const numericValue = sanitized.endsWith('.')
          ? sanitized
          : sanitized === ''
            ? null
            : parseFloat(sanitized);

        this.ngControl.control?.setValue(
          numericValue === null || (typeof numericValue === 'number' && isNaN(numericValue))
            ? null
            : numericValue,
          { emitEvent: false }
        );

        if (sanitized.includes('.')) {
          input.value = sanitized;
        } else if (sanitized !== '') {
          const parsedValue = parseFloat(sanitized);
          if (!isNaN(parsedValue)) {
            input.value = parsedValue.toLocaleString(undefined, {
              maximumFractionDigits: this.maxFractionDigits(),
            });
          } else {
            input.value = sanitized;
          }
        } else {
          input.value = sanitized;
        }
      }
      else{
        if(this.mode() =='number')
        {
          input.value = value.replace(/\D/g,'');
        }
        else{
          value = value.replace(/\.{2,}/g, '.');
          input.value = value;
        }
        this.ngControl.control?.setValue(!isNaN(Number(value)) ? value : null, { emitEvent: false });
      }
  }
}


@Directive({
  selector: '[appNumberFormatInEnglish]',
  standalone: true,
})
export class NumberFormatInEnglishDirective {
  private el = inject(ElementRef);
  private ngControl = inject(NgControl);


  @HostListener('input', ['$event']) onInput(event: any) {
    const input = event.target;
    let value = input.value;
    // Replace Arabic numerals with standard English numerals
    value = value
      .replace(/٠/g, '0')
      .replace(/١/g, '1')
      .replace(/٢/g, '2')
      .replace(/٣/g, '3')
      .replace(/٤/g, '4')
      .replace(/٥/g, '5')
      .replace(/٦/g, '6')
      .replace(/٧/g, '7')
      .replace(/٨/g, '8')
      .replace(/٩/g, '9');
      input.value = value;
  }
}
